module.exports = __webpack_public_path__ + "img/avatar3.1016e1c1.png";